import { render, staticRenderFns } from "./ModalUpdateDataselection.vue?vue&type=template&id=6a728eb4&"
import script from "./ModalUpdateDataselection.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateDataselection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports